module.exports = __webpack_public_path__ + "img/interview.fa8cfdd1.png";